import * as fields from './fields'

export const passwordValidade = (value) => {
  const passwordErrors = {
    minimumEight: true,
    uppercaseLetter: true,
    lowercaseLetter: true,
    oneSymbol: true,
    oneNumber: true
  }

  // eslint-disable-next-line no-useless-escape
  if (/^[A-Za-z\d@$!%*\/#?\-.)(&]{8,}$/.test(value)) {
    passwordErrors.minimumEight = false
  }

  if (/^(?=.*[A-Z])/.test(value)) {
    passwordErrors.uppercaseLetter = false
  }

  if (/^(?=.*[a-z])/.test(value)) {
    passwordErrors.lowercaseLetter = false
  }

  // eslint-disable-next-line no-useless-escape
  if (/^(?=.*[@$!%*\/#?\-.)(&])/.test(value)) {
    passwordErrors.oneSymbol = false
  }

  if (/^(?=.*\d)/.test(value)) {
    passwordErrors.oneNumber = false
  }

  return passwordErrors
}

export const textFieldValidations = (value, validate) => {
  if (!validate || !value) return null

  if (validate === 'cpf' && !fields.CPF_REGEX_VALIDATE.test(value)) {
    return 'CPF inválido'
  }

  if (validate === 'email' && !fields.EMAIL_VALIDATE.test(value)) {
    return 'E-mail inválido'
  }

  if (validate === 'password') {
    const {
      minimumEight,
      uppercaseLetter,
      lowercaseLetter,
      oneSymbol,
      oneNumber
    } = passwordValidade(value)

    if (
      minimumEight ||
      uppercaseLetter ||
      lowercaseLetter ||
      oneSymbol ||
      oneNumber
    ) {
      return {
        status: 'error',
        message: 'Senha inválida',
        errors: {
          minimumEight,
          uppercaseLetter,
          lowercaseLetter,
          oneSymbol,
          oneNumber
        }
      }
    }
  }

  return null
}
